import NavBar from "../Components/NavBar";
import "../assets/About.css";
import Typewriter from "typewriter-effect";



function About(){
  return (
    <div>
      <div>
        <NavBar/>
          <h6 className = "text">
          Technology has made connections faster and more accessible. Whereas a letter would take at least a few days to arrive,  a text can be sent in a few seconds. However, it has also caused these connections to be more shallow. People drift apart; what was once familiar becomes distant. <br/>
          <br/>
          We hope to shift your drift - to drift towards one another instead of away. We have two goals: self-reflection and reconnections. <br/>
          <br/>
          Drift simulates the reflective nature of sending a letter, or setting a message adrift at sea. It allows people to take their time and feel at ease to speak their mind. <br/>
          <br/>
          By practicing mindfulness amidst the overstimulation of instant messages and text notifications, we will also have the capacity to connect more authentically with those around us. <br/>
          <br/>
          We live in a world where people, relationships, and communities are constantly diverging. We feel compelled to move rapidly because we are afraid of falling behind. What if we could rediscover the value in lost connections; the people who shaped us into who we are today?
          </h6>
      </div>
      <div className = "text2">
        <Typewriter
              onInit={(typewriter) => {
                typewriter.typeString("What was left unsaid?").pauseFor(2000).deleteAll()
                .typeString("How has time changed how you perceive past interactions?").pauseFor(2000).deleteAll()
                .typeString("How have people changed? ").pauseFor(2000).deleteAll()
                .typeString("How have you changed?").pauseFor(2000).deleteAll().start();
              }}
              loop={100}
              />
      </div>
    </div>
  );
};

export default About;
